/**
 * Row colors by print tech.
 * Priority: UV > ProColor > DTF > other
 * Printed rows use green family; unprinted use red/pink family.
 */
export function getOrderRowBackgroundColor(orderType, isPrinted) {
  const type = String(orderType || "").toLowerCase();
  const printed = !!isPrinted;

  if (type.includes("uv")) {
    return printed ? "#99ff99" : "#ff9999";
  }
  if (type.includes("procolor")) {
    return printed ? "#c5e1a5" : "#ffe0b2";
  }
  if (type.includes("dtf")) {
    return printed ? "#ccffcc" : "#ffcccc";
  }
  return printed ? "#66ff66" : "#ff6666";
}

/** Softer palette used on some filter paths */
export function getOrderRowBackgroundColorSoft(orderType, isPrinted) {
  const type = String(orderType || "").toLowerCase();
  const printed = !!isPrinted;

  if (type.includes("uv")) {
    return printed ? "#ccffcc" : "#f9caca";
  }
  if (type.includes("procolor")) {
    return printed ? "#dcedc8" : "#ffe0b2";
  }
  if (type.includes("dtf")) {
    return printed ? "#e6ffe6" : "#ffe5e5";
  }
  return printed ? "#b2f2b2" : "#f4b6b6";
}
